exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-header-header-tsx": () => import("./../../../src/pages/Header/header.tsx" /* webpackChunkName: "component---src-pages-header-header-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-main-panel-panel-tsx": () => import("./../../../src/pages/MainPanel/panel.tsx" /* webpackChunkName: "component---src-pages-main-panel-panel-tsx" */)
}

